import { render, staticRenderFns } from "./RestoFlash.vue?vue&type=template&id=39e2bfec"
import script from "./RestoFlash.vue?vue&type=script&lang=js"
export * from "./RestoFlash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports